<template>
  <div class="m-card-primary m-the-modal-content">
    <form
      autocomplete="off"
      name="the-modal-form"
      @submit.prevent="deleteContenidoNodo"
    >
      <header class="m-the-modal-header">
        <h5>{{ $t('mEditionMapChartNodeTaskModalDelete.title') }}</h5>
        <AtomButtonTheModalCloseIcon/>
      </header>
      <section class="m-the-modal-section">
        <p>
          {{ $t('mEditionMapChartNodeTaskModalDelete.messageDelete.element') }}
          <b>{{ $modal.element.nombre }}</b>
          {{ $t('mEditionMapChartNodeTaskModalDelete.messageDelete.options') }}
        </p>
        <small class="text-color-danger">
          {{ $t('mEditionMapChartNodeTaskModalDelete.messageDelete.notReversed') }}
        </small>
      </section>
      <footer class="m-the-modal-footer">
        <AtomButtonTheModalCancelAction :cancel-text="$t('mEditionMapChartNodeTaskModalDelete.buttonCancel')"/>
        <AtomButtonPrimary :button-primary="buttonPrimary"/>
      </footer>
    </form>
  </div>
</template>

<script>
export default {
  name: 'MoleculeEditionMapChartNodeTaskModalDelete',

  data () {
    return {
      buttonPrimary: {
        action: this.$t('mEditionMapChartNodeTaskModalDelete.buttonPrimary'),
        behavior: 'delete',
        class: 'a-button-danger-primary',
        sending: false,
        type: 'submit'
      },
      inscripcionId: ''
    }
  },

  created () {
    this.inscripcionId = this.$store.getters.getSelectedMap.id_inscripcion
  },

  methods: {
    deleteContenidoNodo () {
      if (!this.buttonPrimary.sending) {
        this.buttonPrimary.sending = true
        this.$services.create('inscripcion', 'updateInscripcionNodoEstadoActivoTarea', { academia: this.$store.getters.getAcademyData.id, nodo: this.$store.getters.getSelectedMapNode.id, estado: 3, nodo_activo_tarea: this.$modal.element.tareas_alumno[this.$modal.element.tareas_alumno.length - 1].id }, [this.inscripcionId])
          .then(response => {
            this.$modal.updateData('readInscripcionNodoActivoTareas')
            this.$modal.closeModal()
            this.$alerts.pushAlert('mEditionMapChartNodeTaskModalDelete', 'deleteContenidoNodo', 'success')
            this.buttonPrimary.sending = false
          })
          .catch(error => {
            console.log(error)
            this.$alerts.pushAlert('mEditionMapChartNodeTaskModalDelete', 'deleteContenidoNodo', 'error', 'a-alert-danger')
            this.buttonPrimary.sending = false
          })
      }
    }
  }
}
</script>
